export const getSelectedPlan = state => state.plan.selected;
export const getLocalUser = state => state.user.current;
